var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.dream_post_detail}},[_c('div',{class:_vm.$style.img},[_c('img',{attrs:{"src":_vm.item.image,"alt":""}})]),_c('div',{attrs:{"id":_vm.$style.message}},[_vm._v(_vm._s(_vm.item.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }